import { render, staticRenderFns } from "./ServicesCategoriesPage.vue?vue&type=template&id=736503b4&scoped=true&"
import script from "./ServicesCategoriesPage.vue?vue&type=script&lang=js&"
export * from "./ServicesCategoriesPage.vue?vue&type=script&lang=js&"
import style0 from "./ServicesCategoriesPage.vue?vue&type=style&index=0&id=736503b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736503b4",
  null
  
)

export default component.exports